import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

const PdpRespRequestHoldToast = React.lazy(() =>
    import(/* webpackChunkName: "PdpRespRequestHoldToastChunk" */ './PdpRespRequestHoldToast')
);

export function PdpRespRequestHoldToastLoaderComponent(props) {
    return (
        <React.Suspense fallback={null}>
            <PdpRespRequestHoldToast
                currency={props.currency}
                displayInfo={props.displayInfo}
                item={props.item}
                userId={props.userId}
            />
        </React.Suspense>
    );
}

PdpRespRequestHoldToastLoaderComponent.propTypes = {
    currency: PropTypes.string,
    displayInfo: PropTypes.object,
    item: PropTypes.object,
    userId: PropTypes.string,
};

export const PdpRespRequestHoldToastLoader = createFragmentContainer(
    PdpRespRequestHoldToastLoaderComponent,
    {
        item: graphql`
            fragment PdpRespRequestHoldToastLoader_item on Item {
                ...PdpRespRequestHoldToast_item
            }
        `,
    }
);
